// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';

// Helpers
import _ from 'lodash';

// Types
type $Props = $Translate & {
  item: {
    ChampionshipId: string;
    RegattaId: string;
  };
  resourceData: Array<$Model<'Regatta'>>;
};

const ChampionshipRegattaFieldsView = function ({
  item,
  resourceData,
  t,
}: $Props) {
  return (
    <Row>
      <Col>
        <AvField
          label={t('Regatta')}
          name={'RegattaId'}
          required
          type={'select'}
          value={item.RegattaId}
        >
          {item.RegattaId === '' && (
            <option />
          )}
          {_.map(
            resourceData,
            (i) => (
              <option
                key={i.id}
                value={i.id}
              >
                {i.Name}
              </option>
            ),
          )}
        </AvField>
      </Col>
    </Row>
  );
};

export default ChampionshipRegattaFieldsView;
